<template>
  <div class="flex h-full items-center justify-center px-4">
    <div class="-mt-5 flex max-w-[260px] flex-col items-center text-center">
      <InfringementReportIcon class="size-[34px] text-gray-800" />
      <h2 class="mt-6 text-[20px] leading-[20px] font-medium text-gray-800">
        Nothing on the docket
      </h2>
      <p class="mt-4 text-[14px] leading-[20px] text-gray-600">
        Infringement matches and reports appear here
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InfringementReportIcon } from '@dacr/icons'
</script>
